import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import ManageLayout from './ManageLayout'
import { hasModule } from './auth'
import { MANAGE_MODULES } from './modules'
import DashboardPage from './pages/DashboardPage'
import UsersPage from './pages/UsersPage'
import DonationsPage from './pages/DonationsPage'
import DonationTypePage from './pages/DonationTypePage'
import GalleryPage from './pages/GalleryPage'
import HeroBannerPage from './pages/HeroBannerPage'
import PagesPage from './pages/PagesPage'
import MenusPage from './pages/MenusPage'
import SettingsPage from './pages/SettingsPage'
import RolesPage from './pages/RolesPage'
import UserReportsPage from './pages/UserReportsPage'
import DonationReportsPage from './pages/DonationReportsPage'

function firstAllowedPath() {
  const first = MANAGE_MODULES.find((m) => hasModule(m.key))
  return first ? first.path : '/'
}

function ManageApp() {
  return (
    <ManageLayout>
      <Switch>
        <Route exact path="/manage">
          {hasModule('dashboard') ? (
            <DashboardPage />
          ) : (
            <Redirect to={firstAllowedPath()} />
          )}
        </Route>
        <Route exact path="/manage/users">
          <UsersPage />
        </Route>
        <Route exact path="/manage/donations">
          <DonationsPage />
        </Route>
        <Route exact path="/manage/donation-type">
          <DonationTypePage />
        </Route>
        <Route exact path="/manage/gallery">
          <GalleryPage />
        </Route>
        <Route exact path="/manage/hero-banner">
          <HeroBannerPage />
        </Route>
        <Route exact path="/manage/pages">
          <PagesPage />
        </Route>
        <Route exact path="/manage/menus">
          <MenusPage />
        </Route>
        <Route exact path="/manage/settings">
          <SettingsPage />
        </Route>
        <Route exact path="/manage/roles">
          <RolesPage />
        </Route>
        <Route exact path="/manage/user-reports">
          <UserReportsPage />
        </Route>
        <Route exact path="/manage/donation-reports">
          <DonationReportsPage />
        </Route>
        <Redirect to="/manage" />
      </Switch>
    </ManageLayout>
  )
}

export default ManageApp
